import React, {useState, useRef, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {
  verifyOTPApi,
  hotelsPaymentCall,
  isBusinessProfileSelector,
  totalPaxSelector,
  paymentModuleOpenSelector,
  paymentsDataSelector,
  hotelReviewActions,
  needPanSelector,
  isPahSelector,
  countryCodesSelector,
  checkinTimeListSelector,
  isVerificationRequiredSelector,
  userVerifiedSelector,
  otpVerificationDoneSelector,
  totalPGAmountSelector,
  panListSelector,
  userInfoReview,
} from '@ibibo/hotels-review-reducer';
import {appConfig} from '@ibibo/hotels-config';
import {commonUtils, reviewUtils} from '@ibibo/hotel-utils';
import generateOTP from '@ibibo/generate-otp-api';
import IconSelector from '@ibibo/icon-selector';

import * as S from './GuestDetailBlock.styles';

import PersonalProfile from '../PersonalProfile/PersonalProfile';
import BusinessProfile from '../BusinessProfile/BusinessProfile';
import SpecialRequestBlock from '../SpecialRequestBlock/SpecialRequestBlock';
import TransactionVerify from '../TransactionVerify/TransactionVerify';

import Modal, {useModal} from '../../../../../shared/components/Modal';
import BrandModalHeader from '../../../../../shared/components/Modal';

const nameDetailsSchema = {nameTitle: commonUtils.titlesMap[0].value, firstName: '', lastName: ''};

const GuestDetailsBlock = ({paymentApiErrCallback}, ref) => {
  const isBusinessProfile = useSelector(isBusinessProfileSelector);
  const dispatch = useDispatch();
  const totalPax = useSelector(totalPaxSelector) || 0;
  const [errors, setErrors] = useState({});
  const [open, setOpen] = useState(true);
  const payModuleOpen = useSelector(paymentModuleOpenSelector);
  const {descBlockSuccess} = useSelector(paymentsDataSelector);
  // const isPan = useSelector(needPanSelector);
  const panList = useSelector(panListSelector);
  const countryCodes = useSelector(countryCodesSelector);
  const {isPah, isPahCC} = useSelector(isPahSelector);
  const checkinTimeList = useSelector(checkinTimeListSelector);
  const isVerificationRequired = useSelector(isVerificationRequiredSelector);
  const userVerified = useSelector(userVerifiedSelector);
  const otpVerificationDone = useSelector(otpVerificationDoneSelector);
  const totalPGAmount = useSelector(totalPGAmountSelector);
  const userInfo = useSelector(userInfoReview);

  const [specialRequestOpen, specialRequestSetOpen] = useState(true);
  const [generateOTPResponse, setGenerateOTPResponse] = useState(null);
  const [otpError, setOTPError] = useState('');

  const {isModalOpen, openModal, closeModal} = useModal();

  const isPan = (panList && panList.message && panList.message.length ? true : false);
  const panMessages = (panList && panList.message ? panList.message : []);

  useEffect(() => {
    if ((specialRequestOpen || open) && payModuleOpen) {
      dispatch(hotelReviewActions.resetPaymentsData());
    }
  }, [open, specialRequestOpen]);

  useEffect(() => {
    if (Array.isArray(countryCodes) && countryCodes.length) {
      const {code} = countryCodes[0];
      updateDetailsExceptName('countryCode', code);
    }
  }, [countryCodes]);

  useEffect(() => {
    if (Array.isArray(checkinTimeList) && checkinTimeList.length) {
      const firstSelection = checkinTimeList[0];
      updateDetailsExceptName('selectedCheckinTime', firstSelection);
    }
  }, [checkinTimeList]);

  useEffect(() => {
    if (payModuleOpen && (open || specialRequestOpen)) {
      setOpen(false);
      specialRequestSetOpen(false);
    }
  }, [payModuleOpen]);

  const callGenerateOTP = async (resend = false) => {
    let fd = new FormData();
    fd.append('mobile', 'true');
    if (resend) {
      fd.append('token', (generateOTPResponse && generateOTPResponse.token? generateOTPResponse.token : ''));
    }
    const resp = await generateOTP(fd);
    if (resp && resp.success) {
      setGenerateOTPResponse(resp.data);
    }
  }

  const callPayment = () => {
    const {status, errors} = reviewUtils.validateTravellerForm({
      formData,
      isBusinessProfile,
      isPan,
    });
    if (status) {
      dispatch(hotelReviewActions.updateTravellerDetails(formData));
      if (isVerificationRequired) {
        openModal();
        callGenerateOTP()
      } else {
        dispatch(hotelsPaymentCall(paymentApiErrCallback, (generateOTPResponse && generateOTPResponse.token? generateOTPResponse.token : '')));
      }
      setErrors({});
    } else {
      !open && setOpen(true);
      window.scrollTo({top: GuestDetailsRef.current.offsetTop, behavior: 'smooth'});
      setErrors(errors);
    }
  };

  const toggleBusinessProfile = () => {
    dispatch(hotelReviewActions.toggleBusinessProfile(!isBusinessProfile));
  };

  const [noOfNameDetails, setNumberOfNameDetails] = useState(1);

  const addGuestField = () => {
    if (noOfNameDetails < totalPax) {
      setNumberOfNameDetails(noOfNameDetails + 1);
      setFormData(state => ({
        ...state,
        nameDetails: [...state.nameDetails, nameDetailsSchema],
      }));
    }
  };

  const [formData, setFormData] = useState({
    nameDetails: Array(noOfNameDetails)
      .fill(1)
      .map(() => {
        return nameDetailsSchema;
      }),
    email: '',
    phoneNumber: '',
    countryCode: '',
    gstNumber: '',
    companyName: '',
    businessEmail: '',
    travellersPan: '',
    travellersPanName: '',
    travellersPanTime: '',
    companyAddress: '',
    companyPhone: '',
    companyEmail: '',
    specialReq: '',
    selectedCheckinTime: '',
  });

  const updateDetailsExceptName = (key: string, value) => {
    setFormData(state => ({...state, [key]: value}));
  };

  const updatePanCheck = (key: string, value) => {
    setFormData(state => ({...state, [key]: (formData.travellersPanTime === '' ? value : '')}));
  };

  const updateNameDetails = (key: string, value, index) => {
    const newNameDetails = {...formData.nameDetails[index], [key]: value};
    setFormData(state => ({
      ...state,
      nameDetails: [
        ...state.nameDetails.slice(0, index),
        newNameDetails,
        ...state.nameDetails.slice(index + 1),
      ],
    }));
  };

  const verifyOTPSuccess = () => {
    dispatch(hotelsPaymentCall(paymentApiErrCallback, (generateOTPResponse && generateOTPResponse.token? generateOTPResponse.token : '')));
    closeModal();
  }

  const verifyOTPError = (err) => {
    setOTPError(err);
  }

  const verifyUser = (otp) => {
    if (otp.length < 4) {
      setOTPError('Please enter otp to authenticate your account');
    } else {
      dispatch(verifyOTPApi({
        otp,
        action: 'provision',
        token: (generateOTPResponse && generateOTPResponse.token? generateOTPResponse.token : '')
      }, verifyOTPSuccess, verifyOTPError));
    }
  }

  React.useImperativeHandle(ref, () => ({
    callPayment
  }));

  const GuestDetailsRef = useRef(null);

  return (
    <>
      <S.GuestDetailsWrapDiv>
        <S.GuestDetailsInnerWrapDiv ref={GuestDetailsRef}>
          <S.GuestTxtWrapDiv>
            <S.VerifiedUserDiv>
              <S.PricingTxtSpan>GUEST DETAILS</S.PricingTxtSpan>
              <S.PricingSubTxtSpan>
                <IconSelector iconKey="singletick" />
                <span>MakeMyTrip will strictly send all the communication to {userInfo.mobile} and {userInfo.email}.</span>
              </S.PricingSubTxtSpan>
              <S.PricingSubTxtSpan>
                <IconSelector iconKey="singletick" />
                <span>Hotels might reach out to the customer on email and contact number provided below.</span>
              </S.PricingSubTxtSpan>
            </S.VerifiedUserDiv>
            <S.VerifiedUserDiv>
              {!open && <S.EditLink onClick={() => setOpen(true)}>EDIT</S.EditLink>}
              <S.CircularDiv onClick={() => setOpen(state => !state)}>
                <S.ArrowDownNewWrap transformstyle={(open && 'rotate(180deg)') || 'rotate(0deg)'} />
              </S.CircularDiv>
            </S.VerifiedUserDiv>
          </S.GuestTxtWrapDiv>
          <S.FormsDIV display={!open && 'none'}>

            <PersonalProfile
              toggleBusinessProfile={toggleBusinessProfile}
              noOfNameDetails={noOfNameDetails}
              addGuestField={addGuestField}
              showAddGuest={noOfNameDetails < totalPax}
              updateDetailsExceptName={updateDetailsExceptName}
              updateNameDetails={updateNameDetails}
              updatePanCheck={updatePanCheck}
              errors={errors}
              isPan={isPan}
              panMessages={panMessages}
              countryCodes={countryCodes}
              checkinTimeList={checkinTimeList}
              userInfo = {userInfo}
            ></PersonalProfile>

            {isBusinessProfile && (
              <BusinessProfile
                updateDetailsExceptName={updateDetailsExceptName}
                errors={errors}
                countryCodes={countryCodes}
              ></BusinessProfile>
            )}

          </S.FormsDIV>
        </S.GuestDetailsInnerWrapDiv>
      </S.GuestDetailsWrapDiv>

      <SpecialRequestBlock
        updateSpecialRequest={updateDetailsExceptName}
        open={specialRequestOpen}
        setOpen={specialRequestSetOpen}
      />

      {!payModuleOpen && descBlockSuccess && (
        <S.CustomButton onClick={callPayment} backgroundColorGreen={isPah || isPahCC}>
          <S.PayBtnWrapDiv>
            <S.PayTxtSpan>
            {(isVerificationRequired && appConfig.isVerificationRequiredButtonText ? `${appConfig.isVerificationRequiredButtonText} ${totalPGAmount > 0 ? `₹${totalPGAmount.toLocaleString('en-IN')}` : ''}` : `PROCEED TO PAY ${totalPGAmount > 0 ? `₹${totalPGAmount.toLocaleString('en-IN')}` : ''}`)}
            </S.PayTxtSpan>
          </S.PayBtnWrapDiv>
        </S.CustomButton>
      )}

      <Modal
        isOpen={isModalOpen}
        closeModal={closeModal}
        hideCloseButton={true}
        modalStyles={{
          width: '30vw',
        }}
      >
        <TransactionVerify
          data={generateOTPResponse}
          otpError={otpError}
          callback={verifyUser}
          resendOTP={callGenerateOTP}
          userVerified={userVerified}
          otpVerificationDone={otpVerificationDone}
          closeModal={closeModal}
        />
      </Modal>

    </>
  );
};
const forwardedComponent = React.forwardRef(GuestDetailsBlock);

export default forwardedComponent;
